import { callApi } from 'utils/api';
import { rateVideoSuccessAction } from '../actions';
import { put } from 'redux-saga/effects';

export function* rateVideoRequestEffect({ payload: { videoId, value } }) {
  try {
    const response = yield callApi(`videos/${videoId}/ratings`, 'POST', { value: value });
    yield put(rateVideoSuccessAction(response.ratingAvg, value));
  } catch (error) {}
}
